import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const SuccessModalOrder = ({ show, message, onClose, redirectPath = "/order" }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        onClose();
        navigate(redirectPath);
      }, 2000);
    }
  }, [show, onClose, navigate, redirectPath]);

  return (
    <Modal show={show} centered backdrop="static">
      <Modal.Body className="text-center p-4">
        <div className="d-flex justify-content-center mb-3">
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              backgroundColor: "#E8F5E9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              width="50"
              height="50"
              viewBox="0 0 24 24"
              fill="none"
              stroke="green"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" stroke="green" />
              <path d="M7 12l3 3 6-6" />
            </svg>
          </div>
        </div>
        <h4 className="fw-bold">Berhasil!</h4>
        <p className="text-muted">{message}</p>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModalOrder;
